import React, { useEffect, useReducer } from "react";
import CartContext from "../cartcontext/CartContext";

const reducer = (currenstate, action) => {
  switch (action.type) {
    case "ADD":
      return [...currenstate, action.payload];
    case "REMOVE":
      return [...currenstate];

    default:
      return currenstate;
  }
};

function init() {
  try {
    const cart = localStorage.getItem("cart");
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error(error);
  }
  return [];
}
function CartProvider({ children }) {
  const [cartState, dispatchCart] = useReducer(reducer, [], init);

  const getSum = () => {
    let sum = 0;
    if (!Array.isArray(cartState)) return 0;
    cartState.forEach((d) => {
      sum = d.qty * d.order.price + sum;
    });
    return sum;
  };

  const getQty = () => {
    let qty = 0;
    if (!Array.isArray(cartState)) return 0;
    cartState.forEach((d) => {
      qty = parseInt(d.qty) + qty;
    });
    return qty;
  };
  const countCart = () => {
    return Array.isArray(cartState) ? cartState.length : 0;
  };

  const IsOpen = () => {
    const date = new Date(2020, 9, 16, 11, 0, 0);
    const startTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      10,
      0,
      0
    );
    const endTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      19,
      0,
      0
    );
    if (date > startTime && date < endTime) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartState));
  }, [cartState]);

  return (
    <div>
      <CartContext.Provider
        value={{
          cartState,
          dispatchCart,
          getSum,
          getQty,
          countCart,
          IsOpen,
        }}
      >
        {children}
      </CartContext.Provider>
    </div>
  );
}

export default CartProvider;
